import './radiobox.scss';
import React from 'react';


export interface IRadioboxProps {
    value: number | string;
    disabled?: boolean;
    label?: string;
    checked: boolean;
    onChange?: (data: IRadioboxProps) => void;
    children?: JSX.Element;
}


export function Radiobox(props: IRadioboxProps) {
    const { onChange, checked, disabled, value, label, children } = props;

    const handleCheck = (data: IRadioboxProps) => {
        if (data.disabled) {
            return;
        }
        if (onChange) {
            onChange(data);
        }
    };

    const cls = `form-radio-box ${checked && 'checked'} ${!!disabled && 'disabled'}`

    return (
        <div
            onClick={() => {
                handleCheck(props);
            }}
        >
            {children}
            <div
                key={value}
                className={cls}
            >
                <span className="input-block"></span>
                <label htmlFor="">{label}</label>
            </div>
        </div>
    );
}
